<div *ngIf="viewModel$ | async as viewModel">
  <div class="label-edit-container">
    <div>
      <label for="customer">{{ this.label }}</label>
    </div>
  </div>
  <p-autoComplete
    [tabindex]="tabIndex"
    [ngModel]="viewModel.value"
    [appControlMeta]="viewModel.field"
    #model="ngModel"
    (onKeyUp)="
      store.dispatch(
        getKeyUpAction({
          field: viewModel.field,
          value: $event.target.value,
          key: $event.key,
        })
      )
    "
    (completeMethod)="
      store.dispatch(
        getSearchFiredAction({
          query: $event.query,
          field: viewModel.field,
        })
      )
    "
    (onFocus)="
      store.dispatch(
        getFocusAction({
          field: viewModel.field,
        })
      )
    "
    (onBlur)="
      store.dispatch(
        getBlurAction({
          field: viewModel.field,
        })
      )
    "
    (onSelect)="
      store.dispatch(
        getSelectCustomerAction({
          existingCustomer: $event.value,
        })
      )
    "
    [optionLabel]="viewModel.field"
    [suggestions]="viewModel.suggestedCustomers"
    [placeholder]="placeholder"
    [style]="{ width: '100%' }"
    [inputStyle]="{ width: '100%', 'margin-top': '0.5rem' }"
    [required]="viewModel.field === 'fullName'"
    [pattern]="viewModel.pattern"
    [disabled]="!viewModel.customerEditable.customerEditable"
    (onShow)="hideDropdownIfBlurred(viewModel.isFocused)"
  >
    <ng-template let-customer pTemplate="item">
      <div class="customer-item">
        <div class="customer-field name">
          {{ customer.givenName }} {{ customer.familyName }}
        </div>
        <div class="customer-field email" *ngIf="viewModel.activeColumns.email">
          {{ customer.email }}
        </div>
        <div class="customer-field phone" *ngIf="viewModel.activeColumns.phone">
          {{ customer.phone }}
        </div>
        <div
          class="customer-field company"
          *ngIf="viewModel.activeColumns.company"
        >
          {{ customer.company }}
        </div>
      </div>
    </ng-template>
  </p-autoComplete>
  <app-validation-messages
    [control]="model.control"
    [requireTouched]="true"
  ></app-validation-messages>
</div>
